export default __webpack_public_path__ + "static/media/icons8-react-native.a060cbe8.svg";